import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AbstractNavigationItemsService, AppCoreModule } from '@discoverer/app-core';
import { environment } from '@env/environment';
import { GraphQLModule } from './graphql.module';
import { NavigationItemsService } from './shared/navigation-items-service';




@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        // Core module of your application
        AppCoreModule.forRoot({
            provide: AbstractNavigationItemsService,
            useClass: NavigationItemsService
        }),
        GraphQLModule.forRoot(environment.ehsp.GraphQlURL, [environment.auth.productKey])
    ],
    providers: [
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
